import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-position",
  "use": "icon-position-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-position\"><path d=\"M512 128c-176.7 0-320 143.3-320 320 0 240 256 448 320 448s320-208 320-448c0-176.7-143.3-320-320-320z m0 512c-106 0-192-86-192-192s86-192 192-192 192 86 192 192-86 192-192 192z\" p-id=\"2247\" fill=\"#1296db\" /><path d=\"M512 320c-70.7 0-128 57.3-128 128s57.3 128 128 128 128-57.3 128-128-57.3-128-128-128z\" p-id=\"2248\" fill=\"#1296db\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/position.svg
// module id = 3sTt
// module chunks = 88